/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Button, Divider, List, Modal, Space, Typography } from 'antd';
import ActivityLink from '../UI/ActivityLink';

// Misc imports
import { capitalize } from '../../utils/string/capitalize';

const DeleteWithReferencesModal = ({
  title='',
  description='',
  entityCount=0,
  chapterSourcesData=[],
  deploymentsData=[],
  isModalOpen=false,
  onModalClose=() => {},
  onModalConfirm=() => {},
  loader=false
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isModalOpen}
      destroyOnClose
      centered
      title={title}
      onCancel={onModalClose}
      className={entityCount > 10 ? 'scrollable-modal' : null}
      footer={[
        <Button
          onClick={onModalClose}
          className="float-left"
        >
          {t('Cancel')}
        </Button>,
        <Button
          onClick={onModalConfirm}
          loading={loader}
          type="primary"
          danger
        >
          {capitalize(t('Delete'))}
        </Button>
      ]}
    >
      <div className="mb-5">
        <Typography.Paragraph>
          {description}
        </Typography.Paragraph>
      </div>

      {
        chapterSourcesData.length > 0 && deploymentsData.length > 0 ? (
          <Typography.Text strong className="mb-0">
            {t('Flows:')}
          </Typography.Text>
        ) : null
      }

      {
        chapterSourcesData.length > 0 ? (
          <List
            dataSource={chapterSourcesData}
            renderItem={(item) => (
              <List.Item key={item}>
                <Space size={20}>
                  <ActivityLink
                    activityId={item}
                    showIcon={false}
                  />
                </Space>
              </List.Item>
            )}
          />
        ) : null
      }

      {
        chapterSourcesData.length > 0 && deploymentsData.length > 0
          ? <Divider className="mt-3 mb-5" />
          : null
      }

      {
        deploymentsData.length > 0 ? (
          <Fragment>
            <Typography.Text strong className=" mb-0">
              {t('Deployments:')}
            </Typography.Text>

            <List
              className="mt-0"
              dataSource={deploymentsData}
              renderItem={(item) => (
                <List.Item key={item}>
                  <Space size={20}>
                    <Typography.Text>
                      {item}
                    </Typography.Text>
                  </Space>
                </List.Item>
              )}
            />
          </Fragment>
        ) : null
      }
    </Modal>
  );
};

DeleteWithReferencesModal.propTypes = {
  title: PropTypes.string,
  action: PropTypes.string,
  description: PropTypes.string,
  entityCount: PropTypes.number,
  isModalOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalConfirm: PropTypes.func,
  loader: PropTypes.bool,
  chapterSourcesData: PropTypes.array,
  deploymentsData: PropTypes.array,
  onShowMore: PropTypes.func
};

export default DeleteWithReferencesModal;
